document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#claim_form') as HTMLFormElement | null;
  if (!form) return;

  // Constantes
  const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB
  const steps = document.querySelectorAll('.step');
  const nextButtons = document.querySelectorAll('.next-step');
  const prevButtons = document.querySelectorAll('.prev-step');
  let currentStep = 0;

  // Elementos del formulario
  const telefonoInput = document.querySelector('input[name="telefono"]') as HTMLInputElement | null;
  const nombreInput = document.querySelector('input[name="nombre"]') as HTMLInputElement | null;
  const docNumberInput = document.querySelector('input[name="doc_number"]') as HTMLInputElement | null;
  const submitBtn = form.querySelector('.wpcf7-submit') as HTMLButtonElement | HTMLInputElement | null;
  const propietarioRadio = document.querySelector('input[name="propietario"][value="Soy propietario del inmueble"]') as HTMLInputElement;
  const representanteRadio = document.querySelector('input[name="propietario"][value="Soy representante del propietario del inmueble"]') as HTMLInputElement;
  const poderLabelText = document.querySelector('.poder-label-text') as HTMLElement;

  // Funciones helper
  function createErrorElement(message: string): HTMLElement {
    const error = document.createElement('div');
    error.className = 'error-message text-red text-sm mt-1';
    error.textContent = message;
    return error;
  }

  function createFileNameElement(fileName: string): HTMLElement {
    const fileElement = document.createElement('div');
    fileElement.className = 'file-name text-green text-sm mt-1';
    fileElement.textContent = `Archivo subido: ${fileName}`;
    return fileElement;
  }

  function removeExistingMessages(container: HTMLElement | null, selector = '.error-message, .file-name') {
    const existingMessage = container?.querySelector(selector) as HTMLElement;
    if (existingMessage) {
      existingMessage.remove();
    }
  }

  function validateFileSize(file: File, label: HTMLElement, fileType: string): boolean {
    removeExistingMessages(label);
    if (file.size > MAX_FILE_SIZE) {
      label.appendChild(createErrorElement(`El archivo de ${fileType} no debe superar los 3MB.`));
      return false;
    }
    label.appendChild(createFileNameElement(file.name));
    return true;
  }

  function getFieldErrorMessage(fieldName: string): string {
    const messages: { [key: string]: string } = {
      'nombre_comercial': 'Seleccione un nombre comercial.',
      'nombre_empresa': 'Seleccione una empresa o razón social.',
      'tipo_persona': 'Seleccione el tipo de persona.',
      'nombre': 'Ingrese el nombre del solicitante.',
      'doc_number': 'Ingrese el DNI o Carné de extranjería.',
      'direccion': 'Ingrese el domicilio del solicitante.',
      'telefono': 'Ingrese un número de teléfono.',
      'correo': 'Ingrese un correo electrónico válido.',
      'tyc': 'Debe aceptar las políticas de protección de datos personales.',
      'tipo_reclamo': 'Seleccione el tipo de reclamo.',
      'detalles_reclamo': 'Describa a detalle los hechos de su reclamo.',
      'solicitud': 'Indique expresamente su(s) solicitud(es).',
      'contrato': 'Debe adjuntar el contrato final de separación o proforma.'
    };
    return messages[fieldName] || 'Campo requerido.';
  }

  // Configuración de protección contra múltiples envíos
  const observer = new MutationObserver(() => {
    if (form.getAttribute('data-status') === 'submitting') {
      submitBtn && (submitBtn.disabled = true);
    } else {
      submitBtn && (submitBtn.disabled = false);
    }
  });
  observer.observe(form, { attributes: true, attributeFilter: ['data-status'] });

  form.addEventListener('submit', (e) => {
    if (form.getAttribute('data-status') === 'submitting') {
      e.preventDefault();
      return false;
    }
    submitBtn && (submitBtn.disabled = true);
  });

  // Configuración de campos de entrada
  function setupInputValidation() {
    telefonoInput?.addEventListener('input', () => {
      telefonoInput.value = telefonoInput.value.replace(/[^0-9]/g, '').slice(0, 9);
    });

    nombreInput?.addEventListener('input', () => {
      nombreInput.value = nombreInput.value.replace(/[^a-zA-Z\sáéíóúÁÉÍÓÚñÑ]/g, '');
    });

    docNumberInput?.addEventListener('input', () => {
      docNumberInput.value = docNumberInput.value.replace(/[^0-9]/g, '').slice(0, 8);
    });
  }

  // Configuración del texto del label de poder
  function updatePoderLabelText() {
    if (!poderLabelText) return;
    if (propietarioRadio?.checked) {
      poderLabelText.textContent = 'Adjuntar DNI';
    } else if (representanteRadio?.checked) {
      poderLabelText.textContent = 'Adjuntar PODER';
    }
  }

  [propietarioRadio, representanteRadio].forEach(radio => {
    radio?.addEventListener('change', updatePoderLabelText);
  });
  updatePoderLabelText();

  // Función de navegación entre pasos
  function showStep(stepIndex: number) {
    steps.forEach((step, index) => {
      step.classList.toggle('hidden', index !== stepIndex);
    });
  }

  // Validación del paso 1
  function validateStep1(): boolean {
    const fields = '[name="nombre_comercial"], [name="nombre_empresa"], [name="tipo_persona"], [name="nombre"], [name="doc_number"], [name="direccion"], [name="telefono"], [name="correo"], [name="tyc"]';
    let valid = validateFields(fields);

    // Validación de archivo según tipo de propietario
    const poderFile = document.querySelector('input[name="poder"]') as HTMLInputElement;
    const poderLabel = document.querySelector('.poder-label') as HTMLElement;
    removeExistingMessages(poderLabel);

    if (representanteRadio?.checked || propietarioRadio?.checked) {
      if (!poderFile?.files?.length) {
        valid = false;
        const errorMsg = propietarioRadio?.checked ? 'Debe adjuntar un archivo de DNI.' : 'Debe adjuntar un archivo de poder.';
        poderLabel?.appendChild(createErrorElement(errorMsg));
      } else {
        const fileType = propietarioRadio?.checked ? 'DNI' : 'poder';
        if (!validateFileSize(poderFile.files[0], poderLabel, fileType)) {
          valid = false;
        }
      }
    }

    return valid;
  }

  // Validación del paso 2
  function validateStep2(): boolean {
    const fields = '[name="tipo_reclamo"], [name="detalles_reclamo"], [name="solicitud"]';
    let valid = validateFields(fields);

    // Validación de archivos
    const contratoFile = document.querySelector('input[name="contrato"]') as HTMLInputElement;
    const evidenciaFile = document.querySelector('input[name="evidencia"]') as HTMLInputElement;
    const contratoLabel = document.querySelector('.contrato-label') as HTMLElement;
    const evidenciaLabel = document.querySelector('.evidencia-label') as HTMLElement;

    // Contrato obligatorio
    removeExistingMessages(contratoLabel);
    if (!contratoFile?.files?.length) {
      valid = false;
      contratoLabel?.appendChild(createErrorElement(getFieldErrorMessage('contrato')));
    } else if (!validateFileSize(contratoFile.files[0], contratoLabel, 'contrato')) {
      valid = false;
    }

    // Evidencia opcional
    if (evidenciaFile?.files?.length) {
      if (!validateFileSize(evidenciaFile.files[0], evidenciaLabel, 'evidencia')) {
        valid = false;
      }
    }

    return valid;
  }

  // Función genérica de validación de campos
  function validateFields(selector: string): boolean {
    const fields = document.querySelectorAll(selector);
    let valid = true;

    fields.forEach((field) => {
      if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) {
        removeExistingMessages(field.parentElement);

        const isEmpty = (field.type === 'checkbox' && !(field as HTMLInputElement).checked) ||
                       (field.type === 'select-one' && !(field as HTMLSelectElement).value) ||
                       (field.type !== 'checkbox' && field.type !== 'select-one' && !field.value.trim());

        if (isEmpty) {
          valid = false;
          field.parentElement?.appendChild(createErrorElement(getFieldErrorMessage(field.name)));
        }
      }
    });

    return valid;
  }

  // Configuración de navegación
  nextButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (currentStep === 0 && validateStep1()) {
        currentStep++;
        showStep(currentStep);
      } else if (currentStep !== 0) {
        currentStep++;
        showStep(currentStep);
      }
    });
  });

  prevButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
      }
    });
  });

  // Configuración del botón submit para paso 2
  function setupSubmitValidation() {
    const submitButton = document.querySelector('input[type="submit"], button[type="submit"]') as HTMLElement;
    let isValidated = false;

    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        if (currentStep === 1) {
          if (!isValidated) {
            e.preventDefault();
            removeExistingMessages(submitButton.parentElement, '.general-error-message');

            if (validateStep2()) {
              isValidated = true;
              submitButton.click();
            } else {
              const generalError = createErrorElement('Uno o más campos tienen un error. Por favor, revísalos e inténtalo de nuevo.');
              generalError.className = 'general-error-message text-red text-sm mt-2';
              submitButton.parentElement?.appendChild(generalError);
            }
          } else {
            isValidated = false;
          }
        }
      });
    }
  }

  // Configuración de listeners para limpieza de errores
  function setupErrorCleanup() {
    const allFields = document.querySelectorAll('[name]');
    
    allFields.forEach((field) => {
      if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) {
        ['input', 'change'].forEach(eventType => {
          field.addEventListener(eventType, () => {
            removeExistingMessages(field.parentElement);
            
            if (field instanceof HTMLInputElement && field.type === 'file') {
              const labelMap: { [key: string]: string } = {
                'poder': '.poder-label',
                'contrato': '.contrato-label',
                'evidencia': '.evidencia-label'
              };
              
              const label = document.querySelector(labelMap[field.name]) as HTMLElement;
              if (label) {
                removeExistingMessages(label);
                
                if (field.files?.length && eventType === 'change') {
                  const file = field.files[0];
                  if (file.size > MAX_FILE_SIZE) {
                    label.appendChild(createErrorElement(`El archivo de ${field.name} no debe superar los 3MB.`));
                  } else {
                    label.appendChild(createFileNameElement(file.name));
                  }
                }
              }
            }
          });
        });
      }
    });
  }

  // Configuración de archivos y URLs
  function setupFileHandling() {
    const urlweb = window.location.origin === 'https://apros-qa.net.pe'
      ? `${window.location.origin}/dci/wp-content/uploads/advanced-cf7-upload/`
      : `${window.location.origin}/wp-content/uploads/advanced-cf7-upload/`;

    function generateUniqueId(): string {
      return Date.now().toString();
    }

    function getFormattedDate(): string {
      const now = new Date();
      const year = now.getUTCFullYear();
      const month = String(now.getUTCMonth() + 1).padStart(2, '0');
      const day = String(now.getUTCDate()).padStart(2, '0');
      let hours = now.getUTCHours();
      hours = hours % 12 || 12;
      return `${year}${month}${day}${String(hours).padStart(2, '0')}`;
    }

    function handleFileChange(inputName: string, urlFieldName: string) {
      const fileInput = document.querySelector(`input[name="${inputName}"]`) as HTMLInputElement;
      const urlField = document.querySelector(`input[name="${urlFieldName}"]`) as HTMLInputElement;

      if (fileInput && urlField) {
        fileInput.addEventListener('change', () => {
          if (fileInput.files?.length) {
            const file = fileInput.files[0];
            const uniqueId = generateUniqueId();
            const fileExtension = file.name.split('.').pop() || 'bin';
            const baseFileName = file.name.replace(`.${fileExtension}`, '');
            const sanitizedFileName = baseFileName
              .replace(/\s+/g, '-')
              .replace(/[^a-zA-Z0-9-_]/g, '')
              .replace(/-+/g, '-');

            const newFileName = `${uniqueId}-${sanitizedFileName}.${fileExtension}`;
            const fileUrl = `${urlweb}${uniqueId}-${sanitizedFileName}${getFormattedDate()}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, { type: file.type });
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(renamedFile);
            fileInput.files = dataTransfer.files;

            urlField.value = fileUrl;
          }
        });
      }
    }

    ['contrato', 'poder', 'evidencia'].forEach(name => {
      handleFileChange(name, `${name}_url`);
    });
  }

  // Configuración del reloj
  function setupTimeUpdate() {
    const timeInput = document.getElementById('hora_actual') as HTMLInputElement;
    if (timeInput) {
      const updateTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        timeInput.value = `${hours}:${minutes}`;
      };
      updateTime();
      setInterval(updateTime, 30000);
    }
  }

  // Configuración del contador de archivos
  function setupFileCounter() {
    const hiddenCounterInput = document.getElementById('adjuntos_contador') as HTMLInputElement;
    const updateFileCounter = () => {
      const fileInputs = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>;
      let totalFiles = 0;
      fileInputs.forEach((fileInput) => {
        if (fileInput.files) {
          totalFiles += fileInput.files.length;
        }
      });
      if (hiddenCounterInput) {
        hiddenCounterInput.value = totalFiles.toString();
      }
    };

    document.querySelectorAll('input[type="file"]').forEach((fileInput) => {
      fileInput.addEventListener('change', updateFileCounter);
    });
    updateFileCounter();
  }

  // Inicialización
  showStep(currentStep);
  setupInputValidation();
  setupSubmitValidation();
  setupErrorCleanup();
  setupFileHandling();
  setupTimeUpdate();
  setupFileCounter();
});